var _path, _path2, _path3, _path4, _path5, _path6, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTestrailLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.9665 21.4144H0.903503C0.404503 21.4144 0 21.0099 0 20.5109V16.4479C0 15.9489 0.404503 15.5454 0.903503 15.5454H4.9665C5.4655 15.5454 5.8695 15.9489 5.8695 16.4479V20.5109C5.8695 21.0099 5.4655 21.4144 4.9665 21.4144Z",
    fill: "#3CB850"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7394 21.4144H8.67595C8.17745 21.4144 7.77295 21.0099 7.77295 20.5109V16.4479C7.77295 15.9489 8.17745 15.5454 8.67595 15.5454H12.7394C13.2379 15.5454 13.6424 15.9489 13.6424 16.4479V20.5109C13.6424 21.0099 13.2379 21.4144 12.7394 21.4144Z",
    fill: "#3CB850"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.9665 13.6414H0.903503C0.404503 13.6414 0 13.2369 0 12.7384V8.67495C0 8.17645 0.404503 7.77245 0.903503 7.77245H4.9665C5.4655 7.77245 5.8695 8.17645 5.8695 8.67495V12.7384C5.8695 13.2369 5.4655 13.6414 4.9665 13.6414Z",
    fill: "#3CB850"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.9665 5.869H0.903503C0.404503 5.869 0 5.4645 0 4.966V0.9025C0 0.404 0.404503 0 0.903503 0H4.9665C5.4655 0 5.8695 0.404 5.8695 0.9025V4.966C5.8695 5.4645 5.4655 5.869 4.9665 5.869Z",
    fill: "#3CB850"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7394 13.6414H8.67595C8.17745 13.6414 7.77295 13.2369 7.77295 12.7384V8.67495C7.77295 8.17645 8.17745 7.77245 8.67595 7.77245H12.7394C13.2379 7.77245 13.6424 8.17645 13.6424 8.67495V12.7384C13.6424 13.2369 13.2379 13.6414 12.7394 13.6414Z",
    fill: "#FCC200"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_101_16",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 15,
    width: 7,
    height: 7
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5454 15.5454H21.4147V21.4144H15.5454V15.5454Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_101_16)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5119 21.4144H16.4484C15.9499 21.4144 15.5454 21.0099 15.5454 20.5109V16.4479C15.5454 15.9489 15.9499 15.5454 16.4484 15.5454H20.5119C21.0104 15.5454 21.4149 15.9489 21.4149 16.4479V20.5109C21.4149 21.0099 21.0104 21.4144 20.5119 21.4144Z",
    fill: "#E4006D"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestrailLogo);
export default __webpack_public_path__ + "static/media/testrail-logo.2153b3149f3749a85cc4dfd352d55970.svg";
export { ForwardRef as ReactComponent };